import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-risk-unit-detail',
  imports: [DetailPanelComponent, DetailItemComponent, AddressLabelComponent],
  template: `<div class="tw-flex tw-gap-8 tw-pb-8">
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Id" name="riskUnitId" labelCase="none" />
        <app-detail-item label="Type" name="type" />
        <app-detail-item label="NAICS" name="naics" labelCase="none" />
        <app-detail-item
          label="Building Id"
          name="buildingId"
          labelCase="none"
        />
        <app-detail-item label="Description" name="description" />
        <app-detail-item label="Comment" name="comment" />
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Address">
          <ng-template let-data #value>
            <app-address-label
              [street1]="dataSource.address1"
              [city]="dataSource.city"
              [state]="dataSource.state"
              [postalCode]="dataSource.postalCode"
              [county]="dataSource.county"
              [country]="dataSource.country"
            />
          </ng-template>
        </app-detail-item>
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Is primary" name="isPrimary" format="b" />
        <app-detail-item label="Sub type" name="subType" />
        <app-detail-item label="SIC" name="sic" labelCase="none" />
      </app-detail-panel>
    </div>
  </div>`,
  styles: [],
})
export class RiskUnitDetailComponent {
  @Input() dataSource: any;
}
